import { render } from "./App.vue?vue&type=template&id=35e5ad74&scoped=true&bindings={}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=35e5ad74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35e5ad74"

export default script